'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alert = require('./alert');

Object.defineProperty(exports, 'Alert', {
  enumerable: true,
  get: function get() {
    return _alert.Alert;
  }
});

var _bill = require('./bill');

Object.defineProperty(exports, 'Bill', {
  enumerable: true,
  get: function get() {
    return _bill.Bill;
  }
});

var _button = require('./button');

Object.defineProperty(exports, 'Button', {
  enumerable: true,
  get: function get() {
    return _button.Button;
  }
});
Object.defineProperty(exports, 'ButtonGroup', {
  enumerable: true,
  get: function get() {
    return _button.ButtonGroup;
  }
});

var _checkbox = require('./checkbox');

Object.defineProperty(exports, 'Checkbox', {
  enumerable: true,
  get: function get() {
    return _checkbox.Checkbox;
  }
});
Object.defineProperty(exports, 'CheckboxGroup', {
  enumerable: true,
  get: function get() {
    return _checkbox.CheckboxGroup;
  }
});

var _console = require('./console');

Object.defineProperty(exports, 'Console', {
  enumerable: true,
  get: function get() {
    return _console.Console;
  }
});
Object.defineProperty(exports, 'ConsoleButton', {
  enumerable: true,
  get: function get() {
    return _console.ConsoleButton;
  }
});

var _datePicker = require('./date-picker');

Object.defineProperty(exports, 'DateCalendar', {
  enumerable: true,
  get: function get() {
    return _datePicker.DateCalendar;
  }
});
Object.defineProperty(exports, 'MonthCalendar', {
  enumerable: true,
  get: function get() {
    return _datePicker.MonthCalendar;
  }
});
Object.defineProperty(exports, 'DateTimeCalendar', {
  enumerable: true,
  get: function get() {
    return _datePicker.DateTimeCalendar;
  }
});
Object.defineProperty(exports, 'DatePicker', {
  enumerable: true,
  get: function get() {
    return _datePicker.DatePicker;
  }
});
Object.defineProperty(exports, 'TimePicker', {
  enumerable: true,
  get: function get() {
    return _datePicker.TimePicker;
  }
});
Object.defineProperty(exports, 'RangePicker', {
  enumerable: true,
  get: function get() {
    return _datePicker.RangePicker;
  }
});

var _dialog = require('./dialog');

Object.defineProperty(exports, 'Dialog', {
  enumerable: true,
  get: function get() {
    return _dialog.Dialog;
  }
});

var _icon = require('./icon');

Object.defineProperty(exports, 'Icon', {
  enumerable: true,
  get: function get() {
    return _icon.Icon;
  }
});

var _input = require('./input');

Object.defineProperty(exports, 'Input', {
  enumerable: true,
  get: function get() {
    return _input.Input;
  }
});
Object.defineProperty(exports, 'InputGroup', {
  enumerable: true,
  get: function get() {
    return _input.InputGroup;
  }
});

var _menu = require('./menu');

Object.defineProperty(exports, 'Menu', {
  enumerable: true,
  get: function get() {
    return _menu.Menu;
  }
});
Object.defineProperty(exports, 'SubMenu', {
  enumerable: true,
  get: function get() {
    return _menu.SubMenu;
  }
});
Object.defineProperty(exports, 'MenuItem', {
  enumerable: true,
  get: function get() {
    return _menu.MenuItem;
  }
});
Object.defineProperty(exports, 'MenuItemGroup', {
  enumerable: true,
  get: function get() {
    return _menu.MenuItemGroup;
  }
});
Object.defineProperty(exports, 'MenuDivider', {
  enumerable: true,
  get: function get() {
    return _menu.MenuDivider;
  }
});

var _modal = require('./modal');

Object.defineProperty(exports, 'Modal', {
  enumerable: true,
  get: function get() {
    return _modal.Modal;
  }
});

var _pagination = require('./pagination');

Object.defineProperty(exports, 'Pagination', {
  enumerable: true,
  get: function get() {
    return _pagination.Pagination;
  }
});

var _progress = require('./progress');

Object.defineProperty(exports, 'Progress', {
  enumerable: true,
  get: function get() {
    return _progress.Progress;
  }
});

var _radio = require('./radio');

Object.defineProperty(exports, 'Radio', {
  enumerable: true,
  get: function get() {
    return _radio.Radio;
  }
});
Object.defineProperty(exports, 'RadioGroup', {
  enumerable: true,
  get: function get() {
    return _radio.RadioGroup;
  }
});

var _records = require('./records');

Object.defineProperty(exports, 'Records', {
  enumerable: true,
  get: function get() {
    return _records.Records;
  }
});

var _select = require('./select');

Object.defineProperty(exports, 'Select', {
  enumerable: true,
  get: function get() {
    return _select.Select;
  }
});

var _spin = require('./spin');

Object.defineProperty(exports, 'Spin', {
  enumerable: true,
  get: function get() {
    return _spin.Spin;
  }
});

var _table = require('./table');

Object.defineProperty(exports, 'Table', {
  enumerable: true,
  get: function get() {
    return _table.Table;
  }
});

var _tabs = require('./tabs');

Object.defineProperty(exports, 'Tabs', {
  enumerable: true,
  get: function get() {
    return _tabs.Tabs;
  }
});

var _toaster = require('./toaster');

Object.defineProperty(exports, 'Toaster', {
  enumerable: true,
  get: function get() {
    return _toaster.Toaster;
  }
});

var _tree = require('./tree');

Object.defineProperty(exports, 'Tree', {
  enumerable: true,
  get: function get() {
    return _tree.Tree;
  }
});

var _treeSelect = require('./tree-select');

Object.defineProperty(exports, 'TreeSelect', {
  enumerable: true,
  get: function get() {
    return _treeSelect.TreeSelect;
  }
});

var _trigger = require('./trigger');

Object.defineProperty(exports, 'Trigger', {
  enumerable: true,
  get: function get() {
    return _trigger.Trigger;
  }
});

var _timeline = require('./common/timeline');

Object.defineProperty(exports, 'Timeline', {
  enumerable: true,
  get: function get() {
    return _timeline.Timeline;
  }
});

var _upload = require('./upload');

Object.defineProperty(exports, 'Upload', {
  enumerable: true,
  get: function get() {
    return _upload.Upload;
  }
});
Object.defineProperty(exports, 'UploadHelper', {
  enumerable: true,
  get: function get() {
    return _upload.UploadHelper;
  }
});

var _uploadButton = require('./upload-button');

Object.defineProperty(exports, 'UploadButton', {
  enumerable: true,
  get: function get() {
    return _uploadButton.UploadButton;
  }
});

var _workspace = require('./workspace');

Object.defineProperty(exports, 'Workspace', {
  enumerable: true,
  get: function get() {
    return _workspace.Workspace;
  }
});
Object.defineProperty(exports, 'Router', {
  enumerable: true,
  get: function get() {
    return _workspace.Router;
  }
});
Object.defineProperty(exports, 'Page', {
  enumerable: true,
  get: function get() {
    return _workspace.Page;
  }
});

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};